import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/agent/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        // Store BOTH the JWT (primary auth) and the user profile.
        // The backend also sets an HttpOnly session cookie as a fallback, but
        // some browsers block 3rd-party cookies across domains, so we rely on
        // the JWT via localStorage/Authorization header as the primary channel.
        if (data.token) {
          localStorage.setItem("token", data.token);
        }
        if (data.user) {
          localStorage.setItem("user", JSON.stringify(data.user));
        }
        // Clear the session_id fragment from the URL history so refreshing
        // the dashboard doesn't retrigger this callback.
        try {
          window.history.replaceState(null, "", window.location.pathname);
        } catch (e) { /* ignore */ }
        toast.success("Signed in with Google");
        navigate("/agent/dashboard", { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail || err?.message || "Google sign-in failed";
        setError(detail);
        toast.error(detail);
        setTimeout(() => navigate("/agent/login", { replace: true }), 1800);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen grid place-items-center text-sm text-muted-foreground px-6 text-center">
      {error ? (
        <div>
          <div className="font-display text-2xl font-black text-black mb-2">Sign-in failed</div>
          <p>{error}</p>
          <p className="mt-2 text-xs">Redirecting you back…</p>
        </div>
      ) : (
        <div>Signing you in…</div>
      )}
    </div>
  );
}
